import { render, staticRenderFns } from "./BtnExcluirDespesaParceiro.vue?vue&type=template&id=b7e0971a"
import script from "./BtnExcluirDespesaParceiro.vue?vue&type=script&lang=js"
export * from "./BtnExcluirDespesaParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports